import { SxProps, Theme } from '@mui/material';

export const academyStatusClassNames = {
  badge: 'status-badge',
  dot: 'status-dot',
  checkIcon: 'status-check-icon',
};

export const academyStatusStyles = {
  badge: (theme: Theme) =>
    ({
      height: '28px',
      minHeight: '28px',
      border: 0,
      backgroundColor: 'transparent',
      color: theme.palette.text.primary,
      fontSize: theme.typography.caption.fontSize,
      lineHeight: '16px',
      '& .MuiChip-label': {
        display: 'inline-flex',
        alignItems: 'center',
        gap: theme.spacing(0.75),
        padding: 0,
        overflow: 'visible',
        fontSize: theme.typography.caption.fontSize,
        lineHeight: '16px',
      },
      '& .status-dot': {
        width: '18px',
        height: '18px',
      },
    }) as SxProps<Theme>,

  dot: () =>
    ({
      display: 'inline-grid',
      placeItems: 'center',
      width: '20px',
      height: '20px',
      flex: '0 0 auto',
      border: '1px solid #6b7280',
      borderRadius: '999px',
      background: '#ffffff',
      color: '#ffffff',
      '&.full': {
        borderColor: '#0b8f21',
        background: '#0b8f21',
      },
      '&.half': {
        borderColor: '#098beb',
        background: 'conic-gradient(#098beb 0 50%, #ffffff 50% 100%)',
      },
      '& .status-check-icon': {
        width: '76%',
        height: '76%',
      },
    }) as SxProps<Theme>,

  checkIcon: () =>
    ({
      display: 'block',
      width: '1em',
      height: '1em',
      flex: '0 0 auto',
      backgroundColor: 'currentColor',
      mask: 'var(--skill-icon-url) center / contain no-repeat',
      WebkitMask: 'var(--skill-icon-url) center / contain no-repeat',
    }) as SxProps<Theme>,
};
